export default __webpack_public_path__ + "assets/images/a19a4181b0987e783e7d7571cf3f4ba7.svg";